import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchaseApprovalModel } from "../purchaseApprovalModel";
import { IPurchaseApprovalFields } from "../purchaseApprovalType"
import { momentFormat, formatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import YhTag from "@/components/YhTag";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "purchase-approval.transfer": string,
    "purchase-approval.create": string,
    [key: string]: any
}

export function DataTable() {

    const {
        dataSource, selectedRowKeys, pgCfg, descRows, descTotal, rowsDescTotal,
        loadData, setSelectedRowKeys, setDescRows, reset
    } = usePurchaseApprovalModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onLook = (code: string) => {
        let supplierEditKey = "11-5-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }
    useEffect(() => {
        loadData();
    }, [])

    const statusColor: any = {
        "purchase_approval.transfer": 'orange',
        "purchase_approval.init": "blue",
        "purchase_approval.submit": "cyan",
        "purchase_approval.audited": "green",
        "purchase_approval.reject": "red",
    }
    const defaultColumns: ColumnsType<IPurchaseApprovalFields> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => `${i + 1}`,
        }, {
            title: '审批单号',
            width: 120,
            dataIndex: 'code',
            render: (text: any, record: any,) => <YhTootip text={text} onClick={() => onLook(record.id)} />,
        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '审批类型',
            width: 120,
            dataIndex: 'approveTypeName',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '对接人',
            width: 80,
            dataIndex: 'contact',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '联系电话',
            width: 100,
            dataIndex: 'phone',
            render: (text) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '提报数量',
            width: 100,
            dataIndex: 'fillingNum',
            render: (text, res) => <span style={{ color: (res.status == 'purchase_approval.transfer' && text > res.transferNum) ? '#d82007' : '#000' }}>{text}</span>,
        }, {
            title: '转接数量',
            width: 100,
            dataIndex: 'transferNum',
            render: (text, res) => res.status == 'purchase_approval.transfer' ? <span style={{ color: text > res.transferNum ? '#d82007' : '#000' }}>{text}</span> : '---',
        }, {
            title: '创建时间',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '审批人',
            width: 100,
            dataIndex: 'approver',
        }, {
            title: '审批时间',
            width: 140,
            dataIndex: 'approvalTime',
            render: (text) => momentFormat(text)
        }, {
            title: '转接人',
            width: 100,
            dataIndex: 'transferUser',
        }, {
            title: '转接时间',
            width: 140,
            dataIndex: 'transferTime',
            render: (text) => momentFormat(text)
        }, {
            title: '备注',
            width: 140,
            dataIndex: 'note',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseApproval", "roleCodes": roles };
        return getRoleColumns("purchaseApproval", "主单", defaultColumns, params);
    }, [roles, dataSource]);

    //点击行选高亮
    const onRow = (record: IPurchaseApprovalFields) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let findIndexRowKeys = selectedRowKeys.findIndex((item) => (item === id))

        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];
        console.log(findIndexDesc)
        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
        // let findIndex = selectedRowKeys.indexOf(id);
        // let newSelectedRowKeys = [...selectedRowKeys];
        // if (findIndex === -1) {
        //     newSelectedRowKeys.push(id);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // } else {
        //     newSelectedRowKeys.splice(findIndex, 1);
        //     setSelectedRowKeys(newSelectedRowKeys);
        // }
    };
    const onRightClick = (record: IPurchaseApprovalFields) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchaseApprovalFields[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys: selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                // onClick: () => onRow(record.id as string),
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    onRightClick(record)
                }

            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}

        />
    )
}
